import {
  formatOrgNodeKey,
  isSameUnitCode,
  parseOrgNodeKey,
} from "@pdpp/lib-planta";

import { DepartmentAssignment } from "../../countryActivities/types/types";
import { ClientBusinessNode } from "./types";

// List comes from https://github.com/georgzoeller/iso-3166-1-alpha-2/blob/master/index.js#L37
const COUNTRIES = {
  AF: "Afghanistan",
  AX: "Åland Islands",
  AL: "Albania",
  DZ: "Algeria",
  AS: "American Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarctica",
  AG: "Antigua and Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbaijan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Belarus",
  BE: "Belgium",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia, Plurinational State of",
  BQ: "Bonaire, Sint Eustatius and Saba",
  BA: "Bosnia and Herzegovina",
  BW: "Botswana",
  BV: "Bouvet Island",
  BR: "Brazil",
  IO: "British Indian Ocean Territory",
  BN: "Brunei Darussalam",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Cambodia",
  CM: "Cameroon",
  CA: "Canada",
  CV: "Cape Verde",
  KY: "Cayman Islands",
  CF: "Central African Republic",
  TD: "Chad",
  CL: "Chile",
  CN: "China",
  CX: "Christmas Island",
  CC: "Cocos (Keeling) Islands",
  CO: "Colombia",
  KM: "Comoros",
  CG: "Congo",
  CD: "Congo, the Democratic Republic of the",
  CK: "Cook Islands",
  CR: "Costa Rica",
  CI: "Côte d'Ivoire",
  HR: "Croatia",
  CU: "Cuba",
  CW: "Curaçao",
  CY: "Cyprus",
  CZ: "Czech Republic",
  DK: "Denmark",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Dominican Republic",
  EC: "Ecuador",
  EG: "Egypt",
  SV: "El Salvador",
  GQ: "Equatorial Guinea",
  ER: "Eritrea",
  EE: "Estonia",
  ET: "Ethiopia",
  FK: "Falkland Islands (Malvinas)",
  FO: "Faroe Islands",
  FJ: "Fiji",
  FI: "Finland",
  FR: "France",
  GF: "French Guiana",
  PF: "French Polynesia",
  TF: "French Southern Territories",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Germany",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Greece",
  GL: "Greenland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GG: "Guernsey",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard Island and McDonald Mcdonald Islands",
  VA: "Holy See (Vatican City State)",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hungary",
  IS: "Iceland",
  IN: "India",
  ID: "Indonesia",
  IR: "Iran, Islamic Republic of",
  IQ: "Iraq",
  IE: "Ireland",
  IM: "Isle of Man",
  IL: "Israel",
  IT: "Italy",
  JM: "Jamaica",
  JP: "Japan",
  JE: "Jersey",
  JO: "Jordan",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  XK: "Kosovo",
  KP: "Korea, Democratic People's Republic of",
  KR: "Korea, Republic of",
  KW: "Kuwait",
  KG: "Kyrgyzstan",
  LA: "Lao People's Democratic Republic",
  LV: "Latvia",
  LB: "Lebanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libya",
  LI: "Liechtenstein",
  LT: "Lithuania",
  LU: "Luxembourg",
  MO: "Macao",
  MK: "North Macedonia",
  MG: "Madagascar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldives",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshall Islands",
  MQ: "Martinique",
  MR: "Mauritania",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexico",
  FM: "Micronesia, Federated States of",
  MD: "Moldova, Republic of",
  MC: "Monaco",
  MN: "Mongolia",
  ME: "Montenegro",
  MS: "Montserrat",
  MA: "Morocco",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Netherlands",
  AN: "Netherlands Antilles",
  NC: "New Caledonia",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolk Island",
  MP: "Northern Mariana Islands",
  NO: "Norway",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Palestine, State of",
  PA: "Panama",
  PG: "Papua New Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Philippines",
  PN: "Pitcairn",
  PL: "Poland",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Qatar",
  RE: "Réunion",
  RO: "Romania",
  RU: "Russian Federation",
  RW: "Rwanda",
  BL: "Saint Barthélemy",
  SH: "Saint Helena, Ascension and Tristan da Cunha",
  KN: "Saint Kitts and Nevis",
  LC: "Saint Lucia",
  MF: "Saint Martin (French part)",
  PM: "Saint Pierre and Miquelon",
  VC: "Saint Vincent and the Grenadines",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Sao Tome and Principe",
  SA: "Saudi Arabia",
  SN: "Senegal",
  RS: "Serbia",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SG: "Singapore",
  SX: "Sint Maarten (Dutch part)",
  SK: "Slovakia",
  SI: "Slovenia",
  SB: "Solomon Islands",
  SO: "Somalia",
  ZA: "South Africa",
  GS: "South Georgia and the South Sandwich Islands",
  SS: "South Sudan",
  ES: "Spain",
  LK: "Sri Lanka",
  SD: "Sudan",
  SR: "Suriname",
  SJ: "Svalbard and Jan Mayen",
  SZ: "Swaziland",
  SE: "Sweden",
  CH: "Switzerland",
  SY: "Syrian Arab Republic",
  TW: "Taiwan, Province of China",
  TJ: "Tajikistan",
  TZ: "Tanzania, United Republic of",
  TH: "Thailand",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad and Tobago",
  TN: "Tunisia",
  TR: "Turkey",
  TM: "Turkmenistan",
  TC: "Turks and Caicos Islands",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraine",
  AE: "United Arab Emirates",
  GB: "United Kingdom",
  US: "United States",
  UM: "United States Minor Outlying Islands",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuela, Bolivarian Republic of",
  VN: "Viet Nam",
  VG: "Virgin Islands, British",
  VI: "Virgin Islands, U.S.",
  WF: "Wallis and Futuna",
  EH: "Western Sahara",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
} as const;

export const CODE_BY_COUNTRY_NAME = new Map<string, string>();

for (const [key, value] of Object.entries(COUNTRIES)) {
  CODE_BY_COUNTRY_NAME.set(value, key);
}

export const COUNTRY_NAME_BY_CODE = new Map<string, string>();

for (const [key, value] of Object.entries(COUNTRIES)) {
  COUNTRY_NAME_BY_CODE.set(key, value);
}

const ancestorsCache = new Map<string, ReadonlyArray<ClientBusinessNode>>();

export const clearAncestorsCache = (): void => {
  ancestorsCache.clear();
};

export function getBusinessUnitType(
  node: ClientBusinessNode,
): string | undefined {
  const attr = node.attributes?.["businessUnitType"];
  if (typeof attr === "string") return attr;
  return Array.isArray(attr) ? attr[0]?.publicId : undefined;
}

export function getOrgNodeDisplayName(
  node: ClientBusinessNode,
  locale?: string,
): string {
  if (node.type === "country") {
    if (locale === undefined) return node.name;
    return (
      new Intl.DisplayNames(locale, { type: "region" }).of(
        node.name === "CHN" ? "CN" : node.name,
      ) ?? node.name
    );
  }

  if (node.type === "unit") {
    return `${node.name} (${getBusinessUnitType(node) ?? ""}${node.publicId ?? ""})`;
  }

  if (
    (node.type === "division" || node.type === "department") &&
    node.publicId !== ""
  ) {
    return `${node.name} (${node.publicId})`;
  }

  return node.name;
}

export function findMatchingOrgNode(
  orgNodes: ReadonlyArray<ClientBusinessNode>,
  publicId: string | null,
  type: string | null,
): ClientBusinessNode | undefined {
  if (publicId == null || type == null) return undefined;

  const candidates = orgNodes.filter((n) => getBusinessUnitType(n) === type);
  return (
    candidates.find((n) => n.publicId === publicId) ??
    candidates.find((n) => isSameUnitCode(n.publicId, publicId))
  );
}

export function getAncestors(
  nodes: ReadonlyArray<ClientBusinessNode>,
  orgId: string | undefined,
): ReadonlyArray<ClientBusinessNode> {
  if (orgId === undefined) {
    return [];
  }

  if (ancestorsCache.has(orgId)) {
    return ancestorsCache.get(orgId) ?? [];
  }

  const node = nodes.find((n) => n.id === orgId);

  if (node === undefined) {
    return [];
  }

  if (node.parentId === undefined) {
    ancestorsCache.set(orgId, [node]);
    return [node];
  }

  const ancestors = [...getAncestors(nodes, node.parentId), node];
  ancestorsCache.set(orgId, ancestors);
  return ancestors;
}

/**
 * Shared composite key for the full ancestry of an org node. Returns undefined
 * when the node has no resolvable business unit ancestor.
 */
export function buildOrgNodeKey(
  nodes: ReadonlyArray<ClientBusinessNode>,
  orgId: string | undefined,
): string | undefined {
  const ancestors = getAncestors(nodes, orgId);
  const unitNode = ancestors.find((ancestor) => ancestor.type === "unit");
  if (unitNode?.publicId == null || unitNode.publicId === "") return undefined;

  const businessUnitType = getBusinessUnitType(unitNode);
  if (businessUnitType == null || businessUnitType === "") return undefined;

  const departmentNodes = ancestors.filter(
    (ancestor) => ancestor.type === "department",
  );

  return formatOrgNodeKey({
    unitType: businessUnitType,
    unitCode: unitNode.publicId,
    divisionCode: ancestors.find((ancestor) => ancestor.type === "division")
      ?.publicId,
    departmentCode: departmentNodes[0]?.publicId,
    subDepartmentCode: departmentNodes[1]?.publicId,
  });
}

/**
 * Resolves a shared composite key to the deepest node this app knows about,
 * falling back up the path when a division/department/sub-department is
 * unknown here.
 */
export function resolveExternalOrgNode(
  compositeKey: string,
  orgNodes: ReadonlyArray<ClientBusinessNode>,
): string | null {
  if (orgNodes.length === 0) return null;

  const key = parseOrgNodeKey(compositeKey);
  if (key === undefined) return null;

  const unitNode = findMatchingOrgNode(orgNodes, key.unitCode, key.unitType);
  if (unitNode === undefined) return null;

  const divisionNode =
    key.divisionCode == null
      ? undefined
      : orgNodes.find(
          (node) =>
            node.type === "division" &&
            node.publicId === key.divisionCode &&
            node.parentId === unitNode.id,
        );

  const departmentNode =
    divisionNode === undefined || key.departmentCode == null
      ? undefined
      : orgNodes.find(
          (node) =>
            node.type === "department" &&
            node.publicId === key.departmentCode &&
            node.parentId === divisionNode.id,
        );

  const subDepartmentNode =
    departmentNode === undefined || key.subDepartmentCode == null
      ? undefined
      : orgNodes.find(
          (node) =>
            node.type === "department" &&
            node.publicId === key.subDepartmentCode &&
            node.parentId === departmentNode.id,
        );

  return (subDepartmentNode ?? departmentNode ?? divisionNode ?? unitNode).id;
}

export function getChildren(
  nodes: ReadonlyArray<ClientBusinessNode>,
  orgId: string | undefined,
): ReadonlyArray<ClientBusinessNode> {
  const node = nodes.find((n) => n.id === orgId);

  if (node === undefined) {
    return [];
  }

  return nodes.filter((n) => n.parentId === node.id);
}

export function getActivityNameById(
  nodes: ReadonlyArray<ClientBusinessNode>,
  id: string,
): string {
  const node = nodes.find((it) => it.id === id);

  if (node === undefined) {
    return id;
  }

  return node.name;
}

export const getOrgChildrenByParentList = (
  orgNodes: readonly ClientBusinessNode[],
  parentNode: readonly ClientBusinessNode[],
): ClientBusinessNode[] => {
  return orgNodes.filter((node) =>
    parentNode.find((parent) => parent.id === node.parentId),
  );
};

export function getSiblings(
  nodes: ReadonlyArray<ClientBusinessNode>,
  orgId: string | undefined,
): ReadonlyArray<ClientBusinessNode> {
  return getChildren(nodes, nodes.find((n) => n.id === orgId)?.parentId);
}

export function getSelectBreadCrumbs(
  nodes: ReadonlyArray<ClientBusinessNode>,
  orgId: string | undefined,
): ReadonlyArray<ClientBusinessNode> {
  return getAncestors(nodes, orgId).filter((n) => n.id !== orgId);
}

export function getChildrenWithoutActivities(
  nodes: ReadonlyArray<ClientBusinessNode>,
  orgId: string | undefined,
): ReadonlyArray<ClientBusinessNode> {
  return getChildren(nodes, orgId).filter((n) => n.type !== "activity");
}

export function getAllChildren(
  nodes: ReadonlyArray<ClientBusinessNode>,
  orgId: string | undefined,
): ReadonlyArray<ClientBusinessNode> {
  const node = nodes.find((n) => n.id === orgId);

  if (node === undefined) {
    return [];
  }

  const children = nodes.filter((n) => n.parentId === node.id);
  const subChildren = children.flatMap((c) =>
    getAllChildren(nodes, c.id.toString()),
  );
  return [...children, ...subChildren];
}

export function getUnitFromOfficeLocation(
  location: string,
): { code: string; type: "STO" | "CDC" } | undefined {
  let c: string | undefined = undefined;
  let t: "STO" | "CDC" | undefined = undefined;

  if (location.includes("Store") || location.includes("IKEA")) {
    t = "STO";
  }

  if (location.includes("CDC")) {
    t = "CDC";
  }

  if (t !== undefined) {
    c = location.substring(location.length - 3);
  }

  if (c !== undefined && t !== undefined) {
    return { code: c, type: t };
  }
}

/**
 * Returns a helper function that finds the unit name for a given node ID,
 * if it belongs to a relevant unit under a given country.
 */

function getFindUnitNameHelper(
  nodes: ReadonlyArray<ClientBusinessNode>,
  relevantUnitIds: Set<string>,
): (nodeId: string) => string | undefined {
  const nodesMap = new Map(nodes.map((node) => [node.id, node]));

  return function findUnitName(nodeId: string): string | undefined {
    let currentNode = nodesMap.get(nodeId);
    while (currentNode) {
      if (currentNode.type === "unit") {
        return relevantUnitIds.has(currentNode.id)
          ? currentNode.name
          : undefined;
      }
      if (currentNode.parentId === null || currentNode.parentId === undefined)
        break;
      currentNode = nodesMap.get(currentNode.parentId);
    }
    return undefined;
  };
}

/**
 * Retrieves a list of departments (level 7 nodes) that are under relevant units
 * (level 5 nodes) based on the user's country, including the unit name.
 *
 * @param orgStructure - The organization structure containing nodes and levels.
 * @param userCountry - The country code of the user to filter relevant units.
 * @returns An array of departments with the unit name included.
 */

export const getDepartmentsByCountry = (
  nodes: ReadonlyArray<ClientBusinessNode>,
  userCountry: string,
): Array<DepartmentAssignment & { unitName?: string }> => {
  if (!userCountry) {
    return [];
  }

  // Find all level 5 nodes (units) that match the user's country
  const relevantUnits = nodes.filter(
    (node) => node.type === "unit" && node.parentId === userCountry,
  );
  const relevantUnitIds = new Set(relevantUnits.map((unit) => unit.id));

  // Helper to find the unit name for a given node by traversing up the hierarchy
  const findUnitName = getFindUnitNameHelper(nodes, relevantUnitIds);

  // Filter departments (level 7) that are under the relevant units
  return nodes
    .filter(
      (node) => node.type === "department" && findUnitName(node.id as string),
    )
    .map((department) => ({
      ...department,
      unitName: findUnitName(department.id as string), // Add the unit name to the department
    }));
};
